import { render, staticRenderFns } from "./moduleChart.vue?vue&type=template&id=520b7145&"
import script from "./moduleChart.vue?vue&type=script&lang=js&"
export * from "./moduleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports